<ce-layout-header-container class="ReceiptLookupHeader-container">
    <div class="ReceiptLookupHeader-logo-container flex-row flex-center">
        @if (logoUrl() && !logoError) {
        <img src="{{ logoUrl() }}" alt="Company Logo" class="ReceiptLookupHeader-logo" [style.max-width.px]="logoMaxWidth" [style.max-height.px]="logoMaxHeight" (error)="onLogoError()" />
        }
    </div>
</ce-layout-header-container>
